import dashboards from './dashboards'
import masters from './masters'
import roleAndPermission from './roleAndPermission'
import user from './user'
import tonChhosKhor from './tonChhosKhor'
import report from './report'

// ** Merge & Export
export default [...dashboards, ...tonChhosKhor, ...user, ...roleAndPermission, ...masters, ...report]
